export const LangOption = {
  tag: 'button',
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Y A',
  width: '100%',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: 'Z',
  ':hover': { background: 'inkSurface' },
  onClick: (e, el, s) => {
    s.root.update({ lang: s.langCode, activeLangMenu: false })
    try { localStorage.setItem('dental_lang', s.langCode) } catch (e) {}
  },
  FlagEl: { text: (el, s) => s.flag, fontSize: 'A' },
  NameEl: { text: (el, s) => s.name, fontSize: 'Z', color: 'inkText', fontWeight: '500' }
}
